// extracted by css-extract-rspack-plugin
export default {"dialogContent":"CopilotGenerateDescriptionDialog-module__dialogContent__SOVKD"};